import { Pipe, PipeTransform } from '@angular/core';
import { ChampLibre } from '../models/champLibre';

@Pipe({
  name: 'fuitesStatut',
  standalone: true
})
export class FuitesStatutPipe implements PipeTransform {

  transform(fuites?: ChampLibre, ...args: unknown[]): 'success' | 'warning' | 'error' | 'info' {
    return fuites
      ? typeof fuites?.value == 'number'
        ? fuites?.value >= 30
          ? 'error'
          : fuites?.value >= 24
            ? 'warning'
            : 'success'
        : typeof fuites?.value == 'undefined'
          ? 'warning'
          : fuites?.value == 'BONNES'
            ? 'success'
            : fuites?.value == 'ACCEPTABLES'
              ? 'warning'
              : 'error'
      : 'warning';
  }

}
